import { ImageCell } from '@/components/shared/ImageCell';
import type { Neighborhood } from '@/config/objects/neighborhoods';

interface NeighborhoodImageCellProps {
  neighborhood?: Neighborhood;
  size?: 'sm' | 'lg';
}

/**
 * Editable neighborhood image cell component with upload and delete actions
 */
export function NeighborhoodImageCell({ neighborhood, size = 'sm' }: NeighborhoodImageCellProps) {
  return (
    <ImageCell
      item={neighborhood}
      endpoint="/neighborhoods"
      entityName="Neighborhood"
      imageLabel="Neighborhood Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
